import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  termsAndConditions: {
    id: 'privacyFooter.termsAndConditions',
    defaultMessage: 'Terms and Conditions',
  },
  privacyPolicy: {
    id: 'privacyFooter.privacyPolicy',
    defaultMessage: 'Privacy Policy',
  },
  cookieSettings: {
    id: 'privacyFooter.cookieSettings',
    defaultMessage: 'Cookie Settings',
  },
  yourPrivacyChoices: {
    id: 'privacyFooter.yourPrivacyChoices',
    defaultMessage: 'Your Privacy Choices',
  },
});
